import React from 'react';

import { PageHeaderMeta } from '@/components/PageHeaderMeta/PageHeaderMeta';
import useAddNotificationCountToTitle from '@/hooks/useAddNotificationCountToTitle';
import { useAppSelector } from '@/redux/hooks';
import { getBaseUrl } from '@/redux/modules/config';

const LiveAuctioneersCapitalHeaderMeta = () => {
    const baseUrl = useAppSelector(getBaseUrl);

    React.useEffect(() => {
        //@ts-expect-error
        var handler = window.lendflow.create({
            env: 'wqo4xA53gcMFnvDgL4U18V4NVObWjjn6',
            product: 'leadfunding',
            viewProduct: '1',
        });
        handler.initalisebutton('#start-funding');
    }, []);

    React.useEffect(() => {
        //@ts-expect-error
        var handler = window.lendflow.create({
            env: 'wqo4xA53gcMFnvDgL4U18V4NVObWjjn6',
            product: 'leadfunding',
            viewProduct: '1',
        });
        handler.initalisebutton('#start-funding-2');
    }, []);

    let canonical = `${baseUrl}/capital`;

    const title = useAddNotificationCountToTitle('LiveAuctioneers Capital');

    return (
        <>
            <PageHeaderMeta
                canonical={canonical}
                title={title}
            >
                <link
                    href=""
                    rel="shortcut icon"
                />
                <script src="https://unpkg.com/mq-genie@1.0.0/mq.genie.js"></script>
                <link
                    href="https://fonts.googleapis.com"
                    rel="preconnect"
                />
                <link
                    href="https://fonts.gstatic.com"
                    rel="preconnect"
                />
                <link
                    href="https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;600;700&display=swap"
                    rel="stylesheet"
                />
            </PageHeaderMeta>
            <script src="https://iw.lendflow.com/js/lendflow.js"></script>
        </>
    );
};
export default LiveAuctioneersCapitalHeaderMeta;
